<template>
  <div class="manage-frame">
    <a class="anchor" id="dotJtgg"></a>
    <div class="home-title-bt">
      <div class="home-t-bg">Group Executives</div>
      <p>集团高管</p>
    </div>
    <div class="manage-main">
      <div class="manage-tit"><span>*</span>排名不分先后</div>
      <div class="manage-m-f">
        <div class="manage-data" v-for="(item, i) in list" :key="i" @click="open(item)">
          <div class="data-img">
            <img :src="item.img" alt="照片" />
          </div>
          <div class="data-piece"></div>
          <div class="data-main">
            <div class="data-name">{{ item.name }}</div>
            <div class="data-item">
              <p v-for="(present, y) in item.presentList" :key="y">
                {{ present }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="team-pop" v-show="boxShow">
      <div class="pop-bg"></div>
      <div class="pop-box">
        <img class="close" @click="close()" src="../../../assets/images/join/close2.png" alt="img" />
        <div class="team-pic" v-if="group.img">
          <img :src="group.img" alt="img" />
        </div>
        <div class="mess-box">
          <div class="t-box">
            <p class="name">{{ group.name }}</p>
            <div class="ms" v-if="group.presentList">
              <p class="label" v-for="(item, i) in group.presentList" :key="i">
                {{ item }}
              </p>
            </div>
          </div>
          <div class="desc" style="height: 180px;" v-if="group.minuteList">
            <div class="desc-line" v-for="(item, i) in group.minuteList" :key="i">
              <p v-for="(l, y) in item" :key="y">{{ l }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "manage",
  data() {
    return {
      list: [
        {
          id: "1",
          name: "黄振宇",
          img: require("../../../assets/images/join/figure/hzy.png"),
          presentList: ["集团创始人", "董事长", "战略委员会主席"],
          minuteList: [
            ["百昌科技集团创始人，董事长，全面负责公司战略规划、定位和管理。"],
          ],
        },
        {
          id: "2",
          name: "陈浩",
          img: require("../../../assets/images/join/figure/ch.png"),
          presentList: ["集团战略委员会委员", "副董事长"],
          minuteList: [["原上海闵行区国资委办公室主任"]],
        },
        // {
        //   id: "3",
        //   name: "杨珏震",
        //   img: require("../../../assets/images/join/figure/yyz.png"),
        //   presentList: ["集团战略委员会委员", "副董事长"],
        //   minuteList: [
        //     [
        //       "曾担任国企总经理，并在全球制造500强之一的上海特大型国企集团总部工作多年，经选拔到市委市政府工作部门担任处级领导干部，主要从事经济、科技领域的重大体制改革、政策研究和管理实务。2018年离职作为联合创始人创建科技创新企业并任董事总经理，带领企业创造国内生物新材料领域多项第一，在习总书记视察时获得充分肯定。兼任上海市科委专家库产业管理专家，紫竹国家高新区ET空间创业导师。",
        //     ],
        //   ],
        // },
        {
         id: "4",
         name: "程莉",
          img: require("../../../assets/images/join/figure/cl.jpg"),
          presentList: [
            "集团战略委员会委员",
            "集团总裁",
            "集团业务总部总裁"
          ],
          minuteList: [
            [
              "毕业于南开大学经济系，硕士研究生，金融经济师、投资项目分析师、投融资风险管理师。",
              "曾任职：",
              "中国银行保险监督管理委员会辽宁监管局现场检查处副处长",
              "华融资产管理有限公司（集团）风险管理部、业务审查部副总经理",
              "华融资产管理公司北京分公司党委副书记副总经理",
              "华融融德资产管理有限公司总经理",
              "华融融德（香港）投资管理有限公司董事长。",
            ],
          ],
        },
        // {
        //   id: "7",
        //   name: "曹建博",
        //   img: require("../../../assets/images/join/figure/cjb.jpg"),
        //   presentList: ["集团副总裁"],
        //   minuteList: [
        //     [
        //      "中央金融企业14年工作经验，兼具甲乙方背景，曾就职于中央汇金投资有限责任公司和申万宏源证券承销保荐有限责任公司，深度参与国有金融机构注资改制和整合重组工作，熟悉汇金系控参股金融机构股权管理工作流程，并承揽承做过多家金融机构的股权融资、债权融资、并购重组、财务顾问业务。",
        //     ],
        //   ],
        //  },
        {
          id: "32",
          name: "谭斌",
          img: require("../../../assets/images/join/figure/tb.png"),
          presentList: ["集团副总裁"],
          minuteList: [
            ["毕业于中南财经政法大学国际经济法专业，原中国信达资产管理股份有限公司总部专职审批人，是中国最早一批从事不良资产处置的专业人士，从业逾20年。先后在中国信达海南、江苏分公司任职，在法律、投行、资产处置等多个岗位参与了众多重大项目处置工作。后在信达总部任专职审批人，期间审核了涉及一百多亿不良资产的项目处置方案。离开信达后，任某大型混合所有制不良资产管理公司首席投资人，主导公司大部分不良资产项目的投资、管理和处置。"],
          ],
        },
        // {
        //   id: "5",
        //   name: "陈一鸣",
        //   img: require("../../../assets/images/join/figure/cym.png"),
        //   presentList: [
        //     "集团副总裁",
        //     "兼任集团战略委员会委员",
        //     "分管集团创投中心"
        //   ],
        //   minuteList: [
        //     [
        //       "毕业于清华大学法学院知识产权专业。曾任上海佳和金属制品有限公司（中美合资）董事长助理、北京小马奔腾文化传媒股份有限公司董事办主任，于2021年加入百昌科技。",
        //     ],
        //   ],
        // },
        // {
        //   id: "13",
        //   name: "吴玉玲",
        //   img: require("../../../assets/images/join/figure/wyl.png"),
        //   presentList: ["广东百昌总经理", "股东", "战略委员会委员"],
        //   minuteList: [
        //     [
        //       "中国首批不良资产行业的专业管理人才，拥有23年另类资产管理工作经验，先后在银行、信达资产管理公司、幸福人寿保险公司、广州德赛资产管理公司担任高管职务。以优化生产要素再次配置、助力国家经济结构调整为企业使命，立足粤港澳大湾区，以专业和科技创新提供另类资产交易、配资、处置等全产业链服务，打造合作共赢、和谐共生的产业生态链，为投资人提供更好的服务，为企业创造更高的利润！",
        //     ],
        //   ],
        // },
        {
          id: "12",
          name: "盛凡",
          img: require("../../../assets/images/join/figure/sf.png"),
          presentList: ["集团战略委员会委员", "浙江公司总经理"],
          minuteList: [
            [
              "百昌科技浙江子公司，服务于中国特殊资产最活跃的市场，力争打造中国特殊资产处置服务行业共同富裕的朋友圈和生态圈。",
            ],
            [
              "浙江公司全面主持工作东兴证券股份有限公司杭州凤起路营业部中国东方资产管理股份有限公司浙江省分公司",
            ],
          ],
        },
        {
          id: "11",
          name: "赵雪松",
          img: require("../../../assets/images/join/figure/zxs.png"),
          presentList: ["集团战略委员会委员", "四川公司总经理"],
          minuteList: [
            [
              "23年的金融从业及管理经验，具有对宏观市场精准分析和判断能力，能够依据宏观经济形式及金融政策导向及时把握和调整企业资金策略，有着极强的风控意识和风险把握能力。",
            ],
            [
              "个人过往履历：",
              "中国华融四川分公司 党委委员 副总经理",
              "蓝光发展股份有限公司 四川首席资金官",
              "蓝润地产集团 副总裁",
            ],
          ],
        },
        {
          id: "23",
          name: "毛家祺",
          img: require("../../../assets/images/join/figure/mjq.png"),
          presentList: ["集团战略委员会委员", "上海公司总经理"],
          minuteList: [
            [
              "拥有多年金融与不良资产管理及处置经验。曾任职于华侨银行（中国）有限公司等多家金融机构，长期从事于营销管理及风险控制岗位，于2017年加入百昌科技。",
            ],
          ],
        },
        {
          id: "14",
          name: "张培延",
          img: require("../../../assets/images/join/figure/zpy.png"),
          presentList: ["集团战略委员会委员", "东北公司总经理"],
          minuteList: [
            [
              "曾就职于大型国有商业银行、股份制银行、外资银行国内唯一服务商、地方AMC,任高管20余年，熟悉各金融机构运营规则及金融市场工具，经历2002年至2022年2个周期的不良资产经营，具有丰富的不良资产收购和处置经验，参与过大型企业集团的并购重组及资产处置项目。",
            ],
          ],
        },
        // {
        //   id: "11",
        //   name: "严伟坤",
        //   img: require("../../../assets/images/join/figure/ylw.jpg"),
        //   presentList: [
        //     "上海百昌破立技术有限公司总裁",
        //     "战略委员会委员",
        //   ],
        //   minuteList: [
        //     [
        //       "中国人民大学法学硕士，山西省法学会破产与重组研究会常务理事，国际破产法协会个人会员",
        //     ],
        //   ],
        // },
        // {
        //   id: "29",
        //   name: "黄彪",
        //   img: require("../../../assets/images/join/figure/hb.png"),
        //   presentList: ["集团国租中心副总裁"],
        //   minuteList: [
        //     [
        //       "黄彪，1997年参军，2000年退伍，2000年入职浙江省宁波市象山渔贸发展有限公司，2008年入职上海市大新虹建筑工程有限公司，任副总经理。2023年入职上海百昌科技集团有限公司，任集团国租中心副总裁。",
        //     ],
        //   ],
        // },
        {
          id: "33",
          name: "李凯绅",
          img: require("../../../assets/images/join/figure/lks.png"),
          presentList: ["集团战略委员会委员", "集团产品总监"],
          minuteList: [
            ["8年互联网金融领域实战产品，PMP项目管理，Scrum master敏捷教练认证，主导过百万级大型金融资管系统项目落地，曾负责平安银行消金汽融贷款核心系统，拥有广阔的互联网金融视野，覆盖基金、投资、贷款、不良资产领域科技产品经验"],
          ],
        },
        // {
        //   id: "31",
        //   name: "杨子安",
        //   img: require("../../../assets/images/join/figure/yza.png"),
        //   presentList: ["集团首席法务官", "（候补委员）"],
        //   minuteList: [
        //     [
        //       "上海金茂凯德律师事务所合伙人、同济大学法学学士、美国康奈尔大学法学硕士、环太平洋律师协会会员、外滩金融创新实验区研究员、闵行区青联委员及金融商务与法律界别副秘书长。",
        //     ],
        //   ],
        // },
        // {
        //   id: "10",
        //   name: "许山山",
        //   img: require("../../../assets/images/join/figure/xss.png"),
        //   presentList: ["集团风控中心副总监"],
        //   minuteList: [
        //     [
        //       "持有法律职业资格证、证券从业资格、基金从业资格、企业合规师资格。",
        //       "曾就职于律师事务所，参与家居科技、制造业公司等企业ipo主板上市项目，熟悉资本市场上市与发行、企业破产重整业务、投前尽调及投后管理、公司法公司治理、知识产权法等。",
        //     ],
        //   ],
        // },

        // {
        //   id: "7",
        //   name: "王辉",
        //   img: require("../../../assets/images/join/figure/wh.png"),
        //   presentList: ["重庆百昌总经理"],
        //   minuteList: [
        //     [
        //       "百昌科技重庆子公司，扎根重庆，辐射西南，以百昌科技特殊资产网络拍卖技术平台为核心，搭建资产端、资金端和资产资金服务端高效配置的“三资一中心”服务体系，致力于区域特殊资产的价值发现和价值提升，打造中国特殊资产处置服务行业共同富裕的朋友圈和生态圈。",
        //     ],
        //     [
        //       "个人过往履历：",
        //       "深圳前海翔龙云资产管理有限公司 总经理",
        //       "湛江科技学院 副教授",
        //       "重庆富城资产管理有限公司 副总裁",
        //       "江西金融资产管理股份有限公司 副总经理",
        //       "中国华融资产管理股份有限公司黑龙江分公司 副总经理",
        //       "中国工商银行黑龙江省分行 副科长",
        //     ],
        //     [
        //       "重庆分公司的服务宗旨：",
        //       "为客户创造价值 为员工创造收入 为股东创造利润 为社会创造和谐",
        //     ],
        //   ],
        // },
        // {
        //   id: "16",
        //   name: "刘翔",
        //   img: require("../../../assets/images/join/figure/lx.png"),
        //   presentList: ["山东百昌总经理", "股东"],
        //   minuteList: [
        //     [
        //       "多年银行不良资产投资处置一线实战经历，曾参与管理百亿损失类资产包，熟悉新一轮不良资产各种创新处置模式，擅长企业债务重组和烂尾楼盘活；先后主导负责多个项目的并购重组，拥有丰富的实战经验。",
        //     ],
        //   ],
        // },
        // {
        //   id: "21",
        //   name: "周玲玲",
        //   img: require("../../../assets/images/join/figure/zl.png"),
        //   presentList: ["福建百昌总经理", "股东"],
        //   minuteList: [
        //     [
        //       "北京上海多家知名投行从业经历，十余年金融证券领域工作经验，曾任上海智慧商学院企业管理培训师、福建智才总裁班企业教练，香港挚易盛世集团家族信托中国大区合作商，曾任北京云杉树资管公司福建区域负责人，山西金控福建区域负责人。",
        //     ],
        //   ],
        // },
        // {
        //   id: "24",
        //   name: "王晓凡",
        //   img: require("../../../assets/images/join/figure/wxf.png"),
        //   presentList: ["湖北百昌总经理", "股东"],
        //   minuteList: [
        //     [
        //       "多年的金融行业从业及管理经验，精通金融市场趋势，对国内金融行业有独到深厚的认识，擅于面对金融交易的复杂性，和市场的多变性，能够根据业务发展，不断打破局限壁垒，综合全面多元的铺开业务渠道。",
        //     ],
        //     [
        //       "个人过往履历：",
        //       "湖北元春并购基金管理有限公司 总经理",
        //       "平安银行武汉分行 营业部总经理",
        //       "中信银行武汉分行 支行行长",
        //       "中国工商银行武汉分行 副科长",
        //     ],
        //   ],
        // },
        // {
        //   id: "18",
        //   name: "朱宁",
        //   img: require("../../../assets/images/join/figure/zn.jpg"),
        //   presentList: ["江西百昌总经理", "股东"],
        //   minuteList: [
        //     [
        //       "毕业于陕西财经学院，曾任职于中国农业银行江西省分行，中国长城资产管理股份有限公司江西分公司，后于江西省金融资产管理股份有限公司担任副总经理一职，有丰富的不良资产行业经验与相关项目管理经验，于长城资产管理股份有限公司任职期间，曾获得“长城资产全国十佳项目经理”称号。",
        //     ],
        //   ],
        // },
        // {
        //   id: "19",
        //   name: "陈宇",
        //   img: require("../../../assets/images/join/figure/cy.png"),
        //   presentList: ["甘肃百昌总经理", "股东"],
        //   minuteList: [
        //     [
        //       "十多年不良资产业务经验，为各大银行、 AMC、国际国内不良资产投行提供服务或担任合伙人；作为独立投资人曾成功操盘三十亿不良资产单项业务，历任昆明市中级人民法官、律师事务所主任，拥有执业律师资格和基金管理人资格，同契企业管理（上海）有限公司董事长。",
        //     ],
        //   ],
        // },
      ],
      boxShow: false,
      group: "",
    };
  },
  methods: {
    open(item) {
      this.group = item;
      this.boxShow = true;
    },
    close() {
      this.boxShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.manage-frame {
  position: relative;
  padding-bottom: 120px;

  .anchor {
    position: absolute;
    opacity: 0;
    top: -200px;
  }

  .manage-main {
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;

    .manage-m-f {
      overflow: hidden;
      padding-left: 40px;

      .manage-data {
        float: left;
        width: 280px;
        height: 240px;
        background-color: #fbfbfb;
        position: relative;
        cursor: pointer;

        .data-img {
          position: absolute;
          top: 0;
          right: 0;
          width: 113px;
          height: 113px;
          overflow: hidden;

          img {
            width: 113px;
            height: 113px;
            display: block;
          }
        }

        .data-piece {
          width: 27px;
          height: 27px;
          position: absolute;
          right: 99px;
          top: 99px;
          transition: all 0.5s;
          background-color: #0052d8;
        }

        .data-main {
          padding: 98px 0 0 29px;

          .data-name {
            font-size: 20px;
            font-family: "SourceHanSansCN-Medium";
            font-weight: 500;
            color: #0052d8;
            line-height: 24px;
          }

          .data-item {
            padding-top: 10px;

            p {
              font-size: 14px;
              font-family: "SourceHanSansCN-Medium";
              font-weight: 500;
              color: #666666;
              line-height: 22px;
            }
          }
        }

        &:hover {
          background-color: #f2f3f5;

          .data-piece {
            right: 86px;
            top: 86px;
          }
        }
      }
    }
  }

  .manage-tit {
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 10px 40px;
    color: #666;
    font-size: 14px;
    font-family: "SourceHanSansCN-Medium";
    text-align: right;

    span {
      color: red;
    }
  }

  .team-pop {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;

    /*display: none;*/
    .pop-bg {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }

    .pop-box {
      width: 782px;
      min-height: 520px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
      background: #ffffff;
      padding: 0 80px 50px 0;
      box-sizing: border-box;

      .close {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 32px;
        top: 32px;
        cursor: pointer;
      }

      .team-pic {
        position: absolute;
        left: 0;
        top: 0;

        img {
          width: 200px;
          height: 200px;
        }
      }

      .mess-box {
        width: 446px;
        float: left;
        margin-left: 256px;

        .t-box {
          height: 200px;
          border-bottom: 1px solid #e9ecf0;
          margin-bottom: 24px;
          overflow: hidden;

          .name {
            font-size: 30px;
            color: #0052d9;
            letter-spacing: 0;
            margin-bottom: 8px;
            margin-top: 48px;
          }

          .ms {
            .label {
              font-size: 14px;
              color: #5f6464;
              letter-spacing: 0;
              line-height: 25px;
              margin-bottom: 4px;
            }
          }
        }

        .desc {
          font-size: 14px;
          color: #5f6464;
          letter-spacing: 0;
          line-height: 25px;
          overflow-y: auto;

          .desc-line {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
